// @flow
import React, { Fragment, createRef } from 'react';
import ReactModal from 'react-modal';
import classnames from 'classnames';
import { Container, Col, Row } from 'Components/Grid';
import privacyModel from 'Stores/PrivacyModel';
import Button from 'Components/Button';
import { withRouter } from 'react-router-dom';
import styles from './styles.scss';
import classNames from 'classnames/bind';

type Props = {
  location: {
    pathname: string,
  },
};

type State = {
  showBanner: boolean,
};

class CookieBanner extends React.Component<Props, State> {
  constructor() {
    super();
    this.initialFocusElement = createRef();

    this.state = {
      showBanner: privacyModel.showBanner,
    };

    this.handleBodyScroll(!privacyModel.showBanner);
  }

  static getDerivedStateFromProps() {
    return {
      showBanner: privacyModel.showBanner,
    };
  }

  handleBodyScroll = (scrollEnabled) => {
    if (scrollEnabled) {
      document.body.style.height = '';
      document.body.style.overflowY = '';
    } else {
      document.body.style.height = '100vh';
      document.body.style.overflowY = 'hidden';
    }
  };

  onClick = () => {
    privacyModel.acceptAllCookies();

    if (document.referrer) {
      localStorage.setItem('savedReferrer', document.referrer);
    }

    this.setState({ showBanner: false });
    window.location.reload();
  };

  onlyNecessary = () => {
    privacyModel.acceptOnlyNecessaryCookies();

    this.setState({ showBanner: false });
  };

  componentDidUpdate(_, prevState) {
    const { showBanner } = this.state;

    if (showBanner !== prevState.showBanner) {
      this.handleBodyScroll(!showBanner);
    }
  }

  render() {
    const { pathname } = this.props.location;
    const path = pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
    if (
      !this.state.showBanner ||
      path === '/cookies' ||
      path === '/datenschutz-praeferenzcenter' ||
      path === '/datenschutz' ||
      path === '/impressum'
    ) {
      this.handleBodyScroll(true);

      return null;
    }

    return (
      <Fragment>
        <ReactModal
          isOpen
          onAfterOpen={() => {
            this.initialFocusElement.current.focus();
          }}
          overlayClassName={styles.overlay}
          ariaHideApp={false}
          className={classNames(styles.cookieBanner)}
          shouldCloseOnOverlayClick={false}
          shouldReturnFocusAfterClose={true}
          id="cookie-banner"
          aria={{
            labelledby: 'cookie-banner-headline',
          }}
        >
          <Container>
            <Row>
              <Col cols={12} m={7}>
                <h2 id="cookie-banner-headline" aria-label="Verwalten Sie Ihre Privatsphäre">
                  Verwalten Sie Ihre Privatsphäre
                </h2>
                <p style={{ lineHeight: '1.2rem' }}>
                  Wir verwenden Cookies und ähnliche Technologien, um Ihnen das beste Mazda-Erlebnis
                  bieten zu können. Neben unbedingt erforderlichen sind dies auch optionale
                  Technologien - auch von Drittanbietern, um Webseitenzugriffe und den Erfolg von
                  Werbemaßnahmen zu analysieren, zur Erstellung von individuellen Nutzungsprofilen
                  oder um Ihnen individuellere Werbung auf unseren und dritten Webseiten
                  präsentieren zu können. Diese können auch in Ländern außerhalb der EU (z.B. USA)
                  stattfinden, wo das Risiko des Zugriffs staatlicher Behörden und eingeschränkter
                  Rechtsbehelfsmöglichkeiten nicht auszuschließen ist. Sie helfen uns, wenn Sie auf
                  (Akzeptieren) klicken und damit diesen optionalen Verarbeitungen und
                  Datenweitergaben zustimmen. Sie können Ihre Einwilligung jederzeit mit Wirkung für
                  die Zukunft in Ihrem Datenschutz-Präferenzcenter widerrufen oder ändern. Dort
                  finden Sie zudem weitere Details zur Datenverarbeitung.
                </p>
              </Col>

              <Col m={5}>
                <div className={styles.buttonWrapper}>
                  <Button
                    additionalProps={{
                      ref: this.initialFocusElement,
                    }}
                    ariaControls="cookie-banner"
                    ariaLabel="Alle Cookies akzeptieren"
                    className={styles.cookieButton}
                    label="Akzeptieren"
                    light
                    small
                    onClick={this.onClick}
                  />
                  <Button
                    className={styles.cookieButton}
                    label="Notwendige Cookies akzeptieren"
                    light
                    onClick={this.onlyNecessary}
                    small
                    ariaControls="cookie-banner"
                    ariaLabel="Nur notwendige Cookies akzeptieren"
                  />
                  <Button
                    className={styles.cookieSecondary}
                    label="Datenschutz-Präferenzcenter"
                    href="/datenschutz-praeferenzcenter"
                    aria-label="Öffnet das Datenschutz-Präferenzcenter in einem neuen Fenster oder Tab"
                    target="_blank"
                    variant="secondary"
                    light
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col>
                <div className={classnames([styles.buttonWrapper, styles.policyWrapper])}>
                  <Button
                    label="Datenschutzerklärung"
                    ariaLabel="Öffnet die Datenschutzerklärung in einem neuen Fenster oder Tab"
                    href="/datenschutz"
                    target="_blank"
                    variant="secondary"
                    light
                  />
                  <Button
                    label="Impressum"
                    ariaLabel="Öffnet das Impressum in einem neuen Fenster oder Tab"
                    href="/impressum"
                    target="_blank"
                    variant="secondary"
                    light
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </ReactModal>
      </Fragment>
    );
  }
}

export default withRouter(CookieBanner);
